const DoorFilter = {
  data() {
    return {
      activeDoors: this.activeItems
    }
  },
  props: [
    'activeItems'
  ],
  watch: {
    activeItems(newValue) {
      this.activeDoors = newValue
    }
  },
  methods: {
    handleInput: function(event) {
      bus.$emit('door_filter', event.target.value)
    },
  }
}

export default DoorFilter
